import React from 'react';
import './Loading.scss';

const LoaderRing = () => (
  <div className="lds-ring">
    <div />
    <div />
    <div />
    <div />
  </div>
);

export default LoaderRing;
